import { CascadiaLayoutProps } from "@certn/forms";

import { QuickscreenConsentBaseLayout } from "./QuickscreenConsentBaseLayout";

export function QuickscreenGeneralAuthorizationLayout(
  props: CascadiaLayoutProps
) {
  return (
    <QuickscreenConsentBaseLayout
      layoutProps={props}
      testID="quickscreen-general-authorization-layout"
    />
  );
}
